const LAST_RELOAD_KEY = 'stale-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 10_000;

// After a deploy, an open tab still references the previous build's hashed chunks, which no
// longer exist. Vite emits `vite:preloadError` for any failed dynamic import (route chunks,
// loaders, CSS); reloading fetches the new index.html. The cooldown avoids a reload loop when
// the failure is not a stale build (e.g. offline), letting the error surface instead.
window.addEventListener('vite:preloadError', () => {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
    if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  window.location.reload();
});
